<template>
  <div>
    <span class="d-inline" v-cloak>
      <a href="#none" class="eAppVersion" v-cloak>
        <div v-cloak>
          <span v-if="mode == 'any'">쇼핑몰명 : 파트너 승인 대기</span>
          <span v-else @click="dialog = true">{{ mallName }}</span>
        </div>
      </a>
    </span>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline pt-4">쇼핑몰 정보</span>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-container class="pl-0 pr-0 pt-0">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="쇼핑몰명"
                    required
                    v-model="mallName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="사업자번호"
                    v-model="businessLicenseNumber"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="상호명"
                    required
                    v-model="companyName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="쇼핑몰 이메일"
                    required
                    v-model="mallEmail"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="쇼핑몰 URL 주소"
                    required
                    v-model="mallUrl"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    :items="['자체 솔루션 / 기타']"
                    label="자체 솔루션 / 기타"
                    required
                    v-model="selected"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="담당자명"
                    required
                    v-model="mallManagerName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="담당자 이메일"
                    required
                    v-model="mallManagerEmail"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="담당자휴대폰"
                    required
                    v-model="mallManagerHp"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >닫기</v-btn
            >
            <v-btn color="blue darken-1" text @click="productInfoEditSave()"
              >저장</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style scoped>
[v-clock] {
  display: none;
}
.eAppVersion {
  color: white;
  text-decoration: none;
}
.eAppVersion:hover {
  text-decoration: underline;
}
</style>
<script>
import M from "@/libs/mapping.js";

export default {
  data: () => ({
    dialog: false,
    selected: {},
    mallName: "",
    businessLicenseNumber: "",
    companyName: "",
    mallEmail: "",
    mallUrl: "",
    mallManagerName: "",
    mallManagerEmail: "",
    mallManagerHp: "",
    mode: "any",
    mallState: "",
    mallServiceExpire: "",
  }),
  methods: {
    setInfoParams: async function(params) {
      this.mallName = params.mall_name;
      this.businessLicenseNumber = params.business_number;
      this.companyName = params.business_name;
      this.mallEmail = params.mall_email;
      this.mallUrl = params.mall_url;
      this.mallManagerName = params.mall_manager_name;
      this.mallManagerEmail = params.mall_manager_email;
      this.mallManagerHp = params.mall_manager_hp;
      this.selected = params.solution_name;
      this.mallState = params.mall_state;
    },
    productInfoEditSave: async function() {
      let params = {
        mall_name: this.mallName,
        business_number: this.businessLicenseNumber,
        business_name: this.companyName,
        mall_email: this.mallEmail,
        mall_url: this.mallUrl,
        solution_name: this.selected,
        mall_manager_name: this.mallManagerName,
        mall_manager_hp: this.mallManagerHp,
        mall_manager_email: this.mallManagerEmail,
      };
      try {
        let result = await M.api(M.entry("/put/users/info"), params);
        if (result.mall_id) {
          alert("수정 되었습니다.");
          //
        } else {
          //
          alert("수정 되지 않았습니다.");
        }
      } catch (e) {
        //
        alert("수정 되지 않았습니다.");
      }
    },
  },
  created: function() {
    this.mode = this.$store.state.mode;
  },
};
</script>
